import React from 'react';

type IContextProps = [boolean, React.Dispatch<React.SetStateAction<boolean>>];

export const PosContext = React.createContext<IContextProps>([
  false,
  () => null,
]);
